import type { CSSProperties } from 'react';

import { useAnchorable } from '../../hooks/useAnchorable';

import { section } from './Section.css';

export { section as postSectionClass } from './Section.css';

import type { TPostSectionProps } from './Section.types';
import { buildPostSectionVars } from './sectionStyles';

export const PostSection = (props: TPostSectionProps) => {
  const { element, children } = props;
  const { attrs } = element;
  const { anchorAttributes } = useAnchorable(attrs);

  return (
    <div className={section} style={buildPostSectionVars(attrs) as CSSProperties} {...anchorAttributes}>
      {children}
    </div>
  );
};
